import React from 'react';
import { Card, Row, Col, Form } from 'react-bootstrap';

const sectionHeaderStyle = {
  background: '#0747a6',
  color: '#fff',
  padding: '6px 12px',
  fontWeight: 700,
  fontSize: 13,
  borderRadius: '4px 4px 0 0',
};

const labelStyle = { fontSize: 12, fontWeight: 600, marginBottom: 2 };

const SecaoImobilizado = ({ values, setFieldValue, handleChange, readOnly }) => (
  <Card className="shadow-sm mb-3">
    <div style={sectionHeaderStyle}>Dados do Imobilizado</div>
    <Card.Body>
      <Row>
        <Col md={3} className="mb-2">
          <Form.Label style={labelStyle}>Valor Total Compra</Form.Label>
          <Form.Control
            size="sm"
            type="number"
            step="0.000001"
            value={values.imobilizado.vr_total_compra != null ? values.imobilizado.vr_total_compra : ''}
            onChange={(e) => setFieldValue('imobilizado.vr_total_compra', e.target.value !== '' ? parseFloat(e.target.value) : null)}
            readOnly={readOnly}
          />
        </Col>
        <Col md={3} className="mb-2">
          <Form.Label style={labelStyle}>Código / Etiqueta</Form.Label>
          <Form.Control
            size="sm"
            maxLength={10}
            value={values.imobilizado.codigo_imobilizado}
            onChange={(e) => setFieldValue('imobilizado.codigo_imobilizado', e.target.value)}
            readOnly={readOnly}
          />
        </Col>
      </Row>
    </Card.Body>
  </Card>
);

export default SecaoImobilizado;
